import React, { createContext, PropsWithChildren, useContext } from "react"

import { Context, NewsService } from "./types"
import { useRequestHandler } from "./useRequestHandler"

const NewsContext = createContext({} as Context)

export const useNews = () => useContext(NewsContext)

export const NewsProvider = ({ children, service }: PropsWithChildren & { service: NewsService }) => {
  const state = useRequestHandler(service)
  
  return (<NewsContext.Provider value={state}>
    {children}
  </NewsContext.Provider>)
}
